import { useState, type FormEvent } from "react";
import { supabase } from "@/lib/supabase";
import { friendlyError } from "@/lib/errors";
import { Button } from "@/components/ui/Button";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);

    const { error: authError } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });

    if (authError) {
      // Un mensaje unico para credenciales y para usuario inexistente: decir
      // cual de los dos falla convierte el formulario en un verificador de
      // correos registrados.
      setError(
        authError.message.toLowerCase().includes("invalid")
          ? "Correo o contraseña incorrectos."
          : friendlyError(authError),
      );
      setBusy(false);
    }
    // Si va bien no se apaga `busy`: la sesion cambia y la vista se reemplaza.
  }

  return (
    <main className="grid min-h-dvh place-items-center bg-ground px-5">
      <div className="w-full max-w-[340px]">
        <div className="mb-7">
          <p className="font-mono text-meta uppercase tracking-[0.18em] text-accent">
            Synkro
          </p>
          <h1 className="mt-2 text-2xl font-bold tracking-tight">Ecommerce</h1>
          <p className="mt-1.5 text-ui text-ink-2">
            Panel de administración de tu tienda.
          </p>
        </div>

        <form onSubmit={onSubmit} className="flex flex-col gap-3.5">
          <div className="flex flex-col gap-1.5">
            <label htmlFor="email" className="text-meta font-medium">
              Correo
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-md border border-line bg-surface px-3 py-2 text-ui"
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <label htmlFor="password" className="text-meta font-medium">
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-md border border-line bg-surface px-3 py-2 text-ui"
            />
          </div>

          {error && (
            <p role="alert" className="rounded-md bg-crit-soft px-3 py-2 text-meta text-crit">
              {error}
            </p>
          )}

          <Button type="submit" variant="primary" loading={busy} className="mt-1 w-full">
            Entrar
          </Button>
        </form>
      </div>
    </main>
  );
}
